import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import DateTime from 'react-datetime'
import { Input } from 'reactstrap'
import { FAIcon } from './FAIcon'
import moment from 'moment'
import { DateFormatter } from './Formatters/DateFormatter'

class DateBoxPlainClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    timeFormat: pt.oneOfType([
      pt.string, pt.bool
    ]),
    dateFormat: pt.oneOfType([
      pt.string, pt.bool
    ])
  })

  static defaultProps = {
    timeFormat: false,
    dateFormat: true,
    closeOnSelect: true
  }

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  toggleCalendar = () => {
    this.setState(prev => ({ open: !prev.open }))
  }

  closeCalendar = () => {
    this.setState({ open: false })
  }

  onChange (value) {
    const { input: { onChange }, timeFormat } = this.props
    if (moment.isMoment(value)) {
      if (timeFormat) {
        onChange(value.utc())
      } else {
        onChange(value.startOf('day'))
      }
    } else {
      onChange(null)
    }
    this.closeCalendar()
  }

  renderInput (props, openCalendar, closeCalendar) {
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <Input
          type='text'
          {...props}
          readOnly
          onClick={() => this.toggleCalendar()}
          style={{ ...props.style, paddingRight: '36px', cursor: 'pointer', backgroundColor: '#ffffff' }}
        />
        <span
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            this.toggleCalendar()
          }}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#159351',
            background: 'none',
            border: 'none',
            padding: 0,
            lineHeight: 1,
            zIndex: 10
          }}
        >
          <FAIcon name='calendar'></FAIcon>
        </span>
      </div>
    )
  }

  render () {
    const { closeOnSelect, timeFormat, dateFormat, SessionAccount, isValidDate, ...rest } = this.props

    let roFormat = ''

    if (dateFormat === true & timeFormat === true) {
      roFormat = SessionAccount.DateFormat.DateAndTime
    } else if (dateFormat === true) {
      roFormat = SessionAccount.DateFormat.OnlyDate
    } else {
      roFormat = SessionAccount.DateFormat.OnlyTime
    }

    let df = dateFormat
    if (dateFormat === true) {
      df = SessionAccount.DateFormat.OnlyDate
    }
    let tf = timeFormat
    if (timeFormat === true) {
      tf = SessionAccount.DateFormat.OnlyTime
    }

    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, name, placeHolder, loading, readonly }) =>
          readonly
            ? <Input type='text' readOnly name={`static${name}`} id={`static${name}`} value={DateFormatter.Format(roFormat, SessionAccount, value)} />
            : <DateTime
              open={this.state.open}
              timeFormat={tf} // means we want to show and collect time
              dateFormat={df}
              utc={!timeFormat} // if not collecting time, value should always be utc
              displayTimeZone={timeFormat ? SessionAccount.TimeZoneIdIANA : 'UTC'} // if collecting time, tell component the users timezone
              disabled={loading}
              invalid={showError}
              name={`date${name}`} id={`date${name}`}
              onChange={this.onChange.bind(this)} value={value}
              renderInput={this.renderInput.bind(this)}
              closeOnSelect={closeOnSelect}
              isValidDate={isValidDate}
              inputProps={{ readOnly: true, style: { cursor: 'pointer', backgroundColor: '#ffffff' } }}
            />}
      </FieldLayoutBox>
    )
  }
}

const DateBoxClass = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
  ])
)(DateBoxPlainClass)

export const DateBox = ({ parse, format, fieldType = FieldValueConverters.Date, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={DateBoxClass} /> } // eslint-disable-line
export default DateBox
